module.exports = __webpack_public_path__ + "img/hot.efdd0238.png";